import * as cartReducer from '../reducers/cartReducer';
import { startGetSummary } from '../actions/taxes';
import { isDelivery } from '../selectors/address';
import { setFetching, clearSummary } from '../reducers/summaryReducer';
import {debounce} from 'lodash';

const debouncedCartUpdated = debounce((store, anyway) => {
  const state = store.getState();
  const ticketLines = cartReducer.getTicketlines(state);
  if (anyway || ticketLines.ticketItems.length > 0) {
    store.dispatch(setFetching(true));
    const ticketCalcRequest = {
      ticketItems: ticketLines.ticketItems,
      isDelivery: isDelivery(state),
    };
    store.dispatch(startGetSummary(ticketCalcRequest, 0));
  } else {
    store.dispatch(clearSummary());
  }
}, 250);

const ticketCalculatorMiddleware = store => next => (action) => {
  if (action.type === 'CART_UPDATED') {
    debouncedCartUpdated(store);
  }
  if (action.type === 'PURCHASE_LIMITS_REQUEST') {
    debouncedCartUpdated(store, true);
  }

  next(action);
};

export default ticketCalculatorMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/ticketCalculatorMiddleware.js